import React, { useEffect, useState } from 'react'
import CustomTable from '../../../../Components/Table/CustomTable';
// import ThreeStepsHeadingModal from '../Modal/ThreeStepsModal/ThreeStepsHeadingModal';
// import ThreeStepsCardDesignModal from '../Modal/ThreeStepsModal/ThreeStepsCardDesignModal';
import { Grid } from '@mui/material';
// import OffersCardDesignModal from '../Modal/OffersModal/CommonCardDesignModal';
// import OfferSectionModal from '../Modal/OffersModal/OfferSectionModal';
import { useDispatch, useSelector } from 'react-redux';
import actions from '../../../../ReduxStore/actions';
import { toast } from 'react-toastify';
// import OfferSection from './OffersPreview/OfferSection';
import PreviewComponent from '../../PreviewComponent/PreviewComponent';
import Refer_EarnPage from '../ReferralsContentPreview/ThreeStepsPreview/Refer_EarnPage';
import ThreeStepsSectionModal from '../Modal/ThreeSteps/ThreeStepsSectionModal';

const ThreeStepsSection = () => {


    const tableData = [
        { title: 'The Best Gold', Content: 'Lorem Ipsum is simply dummy text of the...', document: "card.svg", status: "Pending" },
        { title: 'The Best Gold', Content: 'Lorem Ipsum is simply dummy text of the...', document: "card.svg", status: "Pending" },
        { title: 'The Best Gold', Content: 'Lorem Ipsum is simply dummy text of the...', document: "card.svg", status: "Pending" },

        { title: 'The Best Gold', Content: 'Lorem Ipsum is simply dummy text of the...', document: "card.svg", status: "Pending" },

        { title: 'The Best Gold', Content: 'Lorem Ipsum is simply dummy text of the...', document: "card.svg", status: "Pending" },

        { title: 'The Best Gold', Content: 'Lorem Ipsum is simply dummy text of the...', document: "card.svg", status: "Pending" },
        { title: 'The Best Gold', Content: 'Lorem Ipsum is simply dummy text of the...', document: "card.svg", status: "Pending" },
        { title: 'The Best Gold', Content: 'Lorem Ipsum is simply dummy text of the...', document: "card.svg", status: "Pending" },
        { title: 'The Best Gold', Content: 'Lorem Ipsum is simply dummy text of the...', document: "card.svg", status: "Pending" },
        { title: 'The Best Gold', Content: 'Lorem Ipsum is simply dummy text of the...', document: "card.svg", status: "Pending" },
        { title: 'The Best Gold', Content: 'Lorem Ipsum is simply dummy text of the...', document: "card.svg", status: "Pending" },

    ];
    // const tableHeadData = ['S.No', 'Title', 'Content', "Document", 'Status'];

    const permissions = JSON.parse(sessionStorage.getItem("permissions"));

    const [editCardsData, setEditCardsData] = useState(
        [
            { card_title: 'Card 1', card_content: 'Content 1', image: null },
            { card_title: 'Card 2', card_content: 'Content 2', image: null },
            { card_title: 'Card 3', card_content: 'Content 3', image: null },
            { card_title: 'Card 4', card_content: 'Content 4', image: null }
        ]
    );

    //   ================================================

    const role = sessionStorage.getItem("role")
    // csonole

    // const tableData = role === "superAdmin"
    //   ? [{ title: 'The Best Gold', secondtext: 'Staking Company', subtext: 'Lorem Ipsum is simply dummy text of the...', documents: "banner.jpg" }]
    //   : [];

    const tableHeadData = role === "superAdmin" || role === "management"
        ? ['S.No', 'Heading Title', 'Heading Second Text', 'Card Title', 'Creater Name', "Creater Role", "Approver Name", "Approver Role", "Rejector Name", "Rejector Role", "Status"]
        : ['S.No', 'Heading Title', 'Heading Second Text', 'Card Title', 'Status']





    const dispatch = useDispatch();

    const [responseTableData, setResponseTableData] = useState([])
    // const permissions = JSON.parse(sessionStorage.getItem("permissions"));
    console.log(responseTableData, "responseTableDataresponseTableData")
    const { getReferralSectionById } = useSelector(state => state?.getReferralSectionById);
    const { addReferralSection } = useSelector(state => state?.addReferralSection);

    const { updateReferralSection } = useSelector(
        (state) => state?.updateReferralSection
    );

    const { deleteReferralSection } = useSelector(
        (state) => state?.deleteReferralSection
    );




    const { getAllReferralSectionsWithCreatorBySectionName } = useSelector(
        (state) => state?.getAllReferralSectionsWithCreatorBySectionName
    );

    const { getAllReferralSectionsBySectionNameBasedOnCreator } = useSelector(
        (state) => state?.getAllReferralSectionsBySectionNameBasedOnCreator
    );

    const [rowTableData, setRowTableData] = useState([])
    console.log(rowTableData, "rowTableTAdatatattattat")
    console.log(getAllReferralSectionsBySectionNameBasedOnCreator, "rowTableTAdatatattattat111111")

    const { addReferralSectionWithApproval } = useSelector(
        (state) => state?.addReferralSectionWithApproval
    );




    const { updateReferralSectionForReApproval } = useSelector(
        (state) => state?.updateReferralSectionForReApproval
    );


    const { approveReferralSection } = useSelector((state) => state?.approveReferralSection);
    const { rejectReferralSection } = useSelector((state) => state?.rejectReferralSection);




    useEffect(() => {
        const fetchData = async () => {
            if (role === "superAdmin" || role === "management") {

                const data1 = {
                    data: {

                        section_name: "threeSteps" // "Touch" , "getInTouch"
                    },
                    method: "post",
                    apiName: `getAllReferralSectionsBySectionNameWithAllAuthUserDetails`,
                };

                const responseData = await dispatch(actions.GETALLREFERRALSSECTIONSWITHCREATORBYSECTIONNAME(data1));
                setResponseTableData(responseData?.payload)

            }

            else {

                const data1 = {
                    data: {
                        section_name: "threeSteps" // "Touch" , "getInTouch"

                    },
                    method: "post",
                    apiName: `getAllReferralSectionsBySectionNameBasedOnCreator`,
                };

                const responseData = await dispatch(actions.GETALLREFERRALSSECTIONSBYSECTIONNAMEBASEDONCREATOR(data1));
                setResponseTableData(responseData?.payload)


            }
        }


        fetchData();
    }, [addReferralSection, approveReferralSection, rejectReferralSection, addReferralSectionWithApproval, deleteReferralSection, updateReferralSection, updateReferralSectionForReApproval]);

    useEffect(() => {
        const tempArr = [];
        if (role === "superAdmin" || role === "management") {
            getAllReferralSectionsWithCreatorBySectionName?.data?.map((data, index) => {
                return tempArr.push({
               
                    title: data?.heading || '--',
                    secondtext: data?.sub_heading || '--',
                    // subtext: data?.content || '--',
                    section_id: data?.section_id || '--',
                    card_title: data?.additional_data?.card_design
                        ?.map(card => card?.title)
                        .filter(title => title) // Removes undefined or null values
                        .join(", "),
                    // approval_status: data?.approval_status || "--"
                    creatorName: data?.creator?.name || '--',
                    creatorRole: data?.creatorRole?.roleName || '--',
                    approverName: data?.approver?.name || '--',
                    approverRole: data?.approverRole?.roleName || '--',
                    rejectorName: data?.rejector?.name || '--',
                    rejectorRole: data?.rejectorRole?.roleName || '--',
                    approval_status: data?.approval_status
                        ? data.approval_status.charAt(0).toUpperCase() + data.approval_status.slice(1)
                        : "--"
                });
            });
            setRowTableData(tempArr);
        } else {
            getAllReferralSectionsBySectionNameBasedOnCreator?.data?.map((data, index) => {
                return tempArr.push({

                    title: data?.heading || '--',
                    secondtext: data?.sub_heading || '--',
                    // subtext: data?.content || '--',
                    section_id: data?.section_id || '--',
                    // approval_status: data?.approval_status || "--"
                    card_title: data?.additional_data?.card_design
                        ?.map(card => card?.title)
                        .filter(title => title) // Removes undefined or null values
                        .join(", "),
                    approval_status: data?.approval_status
                        ? data.approval_status.charAt(0).toUpperCase() + data.approval_status.slice(1)
                        : "--"

                });
            });
            setRowTableData(tempArr);

        }
    }, [getAllReferralSectionsBySectionNameBasedOnCreator, getAllReferralSectionsWithCreatorBySectionName]);


    console.log(rowTableData, "rowTableDatattattata")



    const handleTableDataDelete = async (id) => {


        const data1 = {
            data: {},
            method: "delete",
            apiName: `deleteReferralSection/${id}`,
        };
        const responseData = await dispatch(actions.DELETEREFERRALSSECTION(data1));
        if (responseData?.payload?.message === "Referral Section soft deleted successfully.") {
            toast.success(responseData?.payload?.message)
        } else {
            toast.error(responseData?.payload?.message)

        }
    }


    // ==========================================================================

    return (
        <Grid container spacing={2}>

            <Grid item xs={12} sx={{ width: "100px" }}>
                <CustomTable
                    tableDelete={permissions?.ContentManagement?.Referrals.delete}
                    // editData={editCardsData}
                    editModalName={ThreeStepsSectionModal}

                    tableView={true}
                    modalVeiwName={PreviewComponent}

                    ModalPreviewComponent1={Refer_EarnPage}
                    handleTableDataDelete={handleTableDataDelete}
                    sectionNameForApproveAndReject="RefreralsSection"

                    section_name="stakeNow"
                    tableEdit={permissions?.ContentManagement?.Referrals.edit}
                    dataCreate={permissions?.ContentManagement?.Referrals.add}
                    tableData={rowTableData} title="Prosperity Steps" tableHeadData={tableHeadData} modalName={ThreeStepsSectionModal} />

            </Grid>
        </Grid>
    )
}

export default ThreeStepsSection